import '../styles.css'
import { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa'

interface AccordionProps {
  children: React.ReactNode;
  title: string;
}

export function Accordion({title, children}:AccordionProps) {
  const [openAccordion, setOpenAccordion] = useState(false);

  return (
    <div className="accordionContainer">
      <section className="accordionHeader" onClick={() => setOpenAccordion(!openAccordion)}>
        <FaChevronRight className={openAccordion ? 'rotate' : ''} />
        <h2>{title}</h2>
      </section>

      {
        openAccordion && <section className="accordionText">
          <p style={{textAlign: 'justify'}}>{children}</p>
        </section>
      }

    </div>
  )
}